import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
export function adminVenueListOptions<T = unknown>(
  kind: 'users' | 'roles' | 'venues',
  revision: number,
) {
  return queryOptions({
    queryKey: [kind, revision],
    gcTime: 0,
    queryFn: async ({ signal }) => {
      const response = await apiClient.get<{ data: T[] }>(`/${kind}`, { signal });
      return response.data.data;
    },
  });
}
